import { Toaster as SonnerToaster, type ToasterProps as SonnerToasterProps, toast } from "sonner";

export interface ToasterProps extends Omit<SonnerToasterProps, "position"> {
  readonly position?: SonnerToasterProps["position"];
}

/**
 * Single mount-once toast surface for an app. Per `packages/ui-primitives.mdc`,
 * apps NEVER import from `sonner` directly — they call `toast.success(...)`
 * etc. via this module.
 */
export function Toaster(props: ToasterProps) {
  return (
    <SonnerToaster
      position={props.position ?? "top-center"}
      richColors
      closeButton
      toastOptions={{
        classNames: {
          toast:
            "rounded-xl border border-[var(--cw-v2-color-border)] bg-[var(--cw-v2-color-surface)] text-[var(--cw-v2-color-text)]",
        },
      }}
      {...props}
    />
  );
}

export { toast };
